var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThankyou(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 162.9 162.9",
    style: {
      enableBackground: "new 0 0 162.9 162.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#279307;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-circle",
    className: "st0",
    d: "M162.9,81.4c0,45-36.5,81.4-81.4,81.4c-45,0-81.4-36.5-81.4-81.4 C0,36.5,36.5,0,81.4,0c0,0,0,0,0,0C126.4,0,162.9,36.5,162.9,81.4C162.9,81.4,162.9,81.4,162.9,81.4z M72,124.6l60.4-60.4 c2.1-2.1,2.1-5.4,0-7.4l-7.4-7.4c-2.1-2.1-5.4-2.1-7.4,0c0,0,0,0,0,0L68.3,98.6l-23-23c-2.1-2.1-5.4-2.1-7.4,0L30.4,83 c-2.1,2.1-2.1,5.4,0,7.4l34.1,34.2C66.6,126.6,70,126.6,72,124.6C72,124.6,72,124.6,72,124.6L72,124.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankyou);
export default __webpack_public_path__ + "static/media/thankyou.1d900e35145e44098880c0d5eb1efd2e.svg";
export { ForwardRef as ReactComponent };